import { create } from "zustand";

type AutomationInboxUiState = {
  search: string;
  unreadOnly: boolean;
  setSearch: (value: string) => void;
  setUnreadOnly: (value: boolean) => void;
  reset: () => void;
};

const DEFAULTS = {
  search: "",
  unreadOnly: false,
};

export const useAutomationInboxUiStore = create<AutomationInboxUiState>((set) => ({
  ...DEFAULTS,
  setSearch: (value) => set({ search: value }),
  setUnreadOnly: (value) => set({ unreadOnly: value }),
  reset: () => set(DEFAULTS),
}));
